import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { isEqual } from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
var FilterLocationsComponent = /** @class */ (function () {
    function FilterLocationsComponent(formBuilder, fuseTranslationLoaderService) {
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.subscriptions = new Subject();
        this.defaultWhere = { archived: false };
        this.filtered = false;
        this.filtersChanged = new BehaviorSubject(this.defaultWhere);
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FilterLocationsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    FilterLocationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.filtersForm = this.formBuilder.group({
            name_contains: null,
            locationGroupId_in: null,
            companyId_in: null,
            archived: false,
            documentNumber_contains: null
        });
        this.filtersForm.valueChanges
            .pipe(takeUntil(this.subscriptions))
            .subscribe(function (filterValue) {
            var where = clearEmptyProperties(filterValue);
            _this.filtersChanged.next(where);
            _this.filtered = !isEqual(where, _this.defaultWhere);
        });
    };
    FilterLocationsComponent.prototype.clearFilters = function () {
        this.filtersForm.patchValue({
            name_contains: null,
            locationGroupId_in: null,
            companyId_in: null,
            archived: false,
            documentNumber_contains: null
        });
    };
    FilterLocationsComponent.prototype.getPropertyValue = function (value, array, property) {
        var item = array.find(function (a) { return a.id === value; });
        return item[property];
    };
    return FilterLocationsComponent;
}());
export { FilterLocationsComponent };
